<template>
  <div style="padding: 15px">
    <div style="margin-bottom: 20px;">
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        highlight-current-row
        highlight-hover-row
        row-id="id"
        height="500"
        :loading="loading"
        :data="tableData"
      >
        <vxe-table-column
          field="orderDetailNumber"
          title="订单编号"
          min-width="300"
        />
        <vxe-table-column field="coalTypeName" title="货物" min-width="200" />
        <vxe-table-column
          field="shipperAddress"
          title="出发地"
          min-width="300"
        />
        <vxe-table-column
          field="consigneeAddress"
          title="目的地"
          min-width="300"
        />
        <vxe-table-column
          field="addressGrade"
          title="地址准确性"
          min-width="100"
        />
        <vxe-table-column
          field="loadGrade"
          title="装卸时效性"
          min-width="100"
        />
        <vxe-table-column
          field="truthGrade"
          title="货源真实性"
          min-width="100"
        />
        <vxe-table-column
          field="timeGrade"
          title="付款时效性"
          min-width="100"
        />
        <vxe-table-column
          field="multipleGrade"
          title="综合满意度"
          min-width="100"
        />
        <vxe-table-column
          v-if="form.driverCode"
          field="shipperName"
          title="托运人"
          min-width="300"
        />
        <vxe-table-column
          v-if="form.userCode"
          field="driverName"
          title="实际承运人"
          min-width="300"
        />
        <vxe-table-column field="gmtCreated" title="评论时间" min-width="200" />
      </vxe-table>
      <vxe-pager
        :loading="loading"
        :current-page.sync="form.pageNum"
        :page-sizes="Pagingconf"
        :page-size.sync="form.pageSize"
        :total="form.total"
        :layouts="[
          'PrevJump',
          'PrevPage',
          'Number',
          'NextPage',
          'NextJump',
          'Sizes',
          'FullJump',
          'Total'
        ]"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>
<script>
import { evaluateList } from "@/api/CustomerService";
export default {
  name: "Detail",
  data() {
    return {
      loading: false,
      tableData: [],
      form: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        driverCode: "",
        userCode: "",
        commentType: 0
      },
      Pagingconf: []
    };
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      this.tableData = [];
      // update by JiaYK start 2021/09/25 11:10 修复评价管理参数遗漏问题
      // this.form.userCode = code
      if (code) this.form.userCode = code;
      // update by JiaYK end 2021/09/25 11:10 修复评价管理参数遗漏问题
      this.form.commentType = 1;
      evaluateList(this.form).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.form.total = response.data.total;
      });
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.form.pageNum = currentPage;
      this.form.pageSize = pageSize;
      this.getInfo();
    }
  }
};
</script>
